import type { CaseStudy } from '../../types/content'
import { bhoomiCoffee } from './bhoomiCoffee'
import { deshmukhRao } from './deshmukhRao'
import { pranaPhysio } from './pranaPhysio'
import { meridianArchitects } from './meridianArchitects'
import { northpulseDashboard } from './northpulseDashboard'

export const caseStudies: CaseStudy[] = [
  bhoomiCoffee,
  deshmukhRao,
  pranaPhysio,
  meridianArchitects,
  northpulseDashboard,
]

export function getCaseStudy(slug: string | undefined): CaseStudy | undefined {
  return caseStudies.find((study) => study.slug === slug)
}
